import { BaseEntity } from '@models';
import { PaymentType } from './payment-type.enum';
import { PaymentRecurrence } from './payment-recurrence.enum';

export class AdditionalService extends BaseEntity {
	name: string;
	description?: string;
	summary?: string;
	serviceType?: string;
	supplier?: string;
	organizationId: string;
	price?: number;
	available?: boolean;
	paymentRecurrence?: PaymentRecurrence;
	paymentType?: PaymentType;
	logoUrl?: string;
}
